import React, {useEffect, useRef, useState} from 'react'
import {Card} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useThemeMode} from '../../../../_metronic/partials'
import Info from '../../../../media/shared-access/ic-info-yellow.svg'
import StorageCard from './StorageCard'
import {useSearchParams} from 'react-router-dom'
import {toast} from 'react-toastify'
import {useAuth} from '../../auth'
import {getAllQuota, getQuotaGraph, getUserList, processUpgradeQuota} from '../core/_requests'
import {ToolTipUI} from '../../widgets/components/UI/ToolTipUI'
import Calendar from '../../../../media/StorageAI/ic-calendar.svg'
import Watch from '../../../../media/StorageAI/ic-watch.svg'
import useGetBillingData from '../../../hooks/useGetBillingData'
import {QuotaBarColumnChart} from './settings/QuotaBarColumnChart'
import {QuotaActivityTypes} from '../core/_models'
import QuotaOverviewGraph from './settings/QuotaOverviewGraph'
import Skeleton from 'react-loading-skeleton'
import {NoDataPage} from '../../resources/components/NoDataPage'
import StorageCardSkeleton from './StorageCardSkeleton'

const StorageAndAIUse = () => {
  const {formatMessage} = useIntl()
  const {mode} = useThemeMode()
  const [isProcessing, setProcessing] = useState<boolean>(false)
  const [queryParams, setQueryParams] = useSearchParams()//eslint-disable-line
  const [, setKey] = useState<number>(0)
  const [initialItems, setInitialItems] = useState<any[]>([])
  const [planDates, setPlanDates] = useState<any>()
  const [selectedDataActivity, setSelectedDataActivity] = useState('thisYear')
  const [quotaOverviewData, setQuotaOverviewData] = useState<QuotaActivityTypes>({
    aiSearchAndRetrievals: [],
    fileProcessing: [],
  })
  const [isLoading, setIsLoading] = useState(true) //eslint-disable-line
  const [isQuotaLoading, setIsQuotaLoading] = useState(true) //eslint-disable-line
  const [graphData, setGraphData] = useState({series: [], categories: []})
  const [userList, setUserList] = useState<any[]>([])
  const [selectedUserIds, setSelectedUserIds] = useState<number[]>([]) // Store selected user IDs

  const handleCheckboxChange = (userId: number) => {
    setSelectedUserIds(
      (prevSelected) =>
        prevSelected.includes(userId)
          ? prevSelected.filter((id) => id !== userId) // Remove if already selected
          : [...prevSelected, userId] // Add if not selected
    )
  }

  const isChecked = (userId: number) => selectedUserIds.includes(userId)

  const [isCumulative, setIsCumulative] = useState(false)
  const [, setActive] = useState(false)
  const dropdownRef = useRef<HTMLDivElement | null>(null)
  const {companyId, setBillingData, setEntitlements, billingData} = useAuth()
  const {getBillingDetailsAPI} = useGetBillingData(companyId!)
  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setActive(false)
    }
  }
  useEffect(() => {
    const getBillingDetails = async () => {
      const result = await getBillingDetailsAPI()
      setBillingData({
        ...result.output,
        transaction_id: result.current_plan_invoice_id,
        company_country: result.company_country,
      })
      setEntitlements(result.entitlement_list)
    }
    if (companyId) {
      getBillingDetails()
    }
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  // const hasFetched = useRef(false);

  async function getQuotas() {
    if (!companyId) {
      return
    }
    // if (hasFetched.current) return; // Prevent multiple calls
    // hasFetched.current = true;
    try {
      const payload = {
        currency: 'USD',
        duration: billingData?.billing_period_unit
          ? `${billingData.billing_period_unit
              .charAt(0)
              .toUpperCase()}${billingData.billing_period_unit.slice(1).toLowerCase()}ly`
          : '',
      }
      const {
        data: {success, data},
      } = await getAllQuota(+companyId!, payload)

      if (success) {
        setInitialItems(data?.addons)
        setPlanDates(data?.dates)
      }
    } catch (error) {
      console.error('Error fetching quotas:', error)
    } finally {
      setIsQuotaLoading(false)
    }
  }
  // Call inside useEffect
  // useEffect(() => {
  //   getQuotas();
  // }, [companyId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (billingData) {
      getQuotas()
    }
  }, [billingData,companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  async function processQuota() {
    setProcessing(true)
    try {
      const {
        data: {success},
      } = await processUpgradeQuota(companyId!, queryParams.get('id') || '')
      if (success) {
        toast.success('Amount added to your account successfully')
        setKey(Math.random())
        // let quotaRechargeData: any = data
      }
      queryParams.delete('id')
      queryParams.delete('state')
      // setQueryParams(queryParams)
    } catch (err) {
      console.log(err)
    } finally {
      setProcessing(false)
    }
  }
  useEffect(() => {
    if (companyId && queryParams.has('id') && queryParams.has('state')) {
      processQuota()
    }
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  async function getOverviewData() {
    if (!companyId) {
      return
    }
    // setIsLoading(true)
    try {
      const userIdsString = selectedUserIds.join(',')
      const {
        data: {success, data},
      } = await getQuotaGraph(+companyId!, selectedDataActivity, userIdsString)
      if (success) {
        setQuotaOverviewData(data)
        const {aiSearchAndRetrievals = [], fileProcessing = []} = data || {}

        // If both datasets are missing, set default values
        if (aiSearchAndRetrievals.length === 0 && fileProcessing.length === 0) {
          setGraphData({series: [], categories: []})
          return
        }

        // Use fileProcessing for categories if aiSearchAndRetrievals is missing
        const categories = (
          aiSearchAndRetrievals.length ? aiSearchAndRetrievals : fileProcessing
        ).map((item: any) => item.xAxis)

        const formattedData: any = {
          series: [
            {
              name: 'Total Chats',
              data: aiSearchAndRetrievals.length
                ? aiSearchAndRetrievals.map((item: any) => item.totalChats)
                : new Array(categories.length).fill(0), // Fill with 0s if missing
            },
            {
              name: 'Total Files',
              data: fileProcessing.length
                ? fileProcessing.map((item: any) => item.totalFiles ?? item.totalChats ?? 0)
                : new Array(categories.length).fill(0),
            },
          ],
          categories,
        }
        setGraphData(formattedData)
      }
    } catch (err) {
      console.log(err)
    } finally {
      // setIsLoading(false)
    }
  }

  useEffect(() => {
    getOverviewData()
  }, [companyId, selectedDataActivity, isCumulative, selectedUserIds]) // eslint-disable-line react-hooks/exhaustive-deps

  const getUsersList = async () => {
    if (!companyId) {
      return
    }
    try {
      const {
        data: {success, data, errors},
      } = await getUserList(companyId)
      if (success) {
        setUserList(data)
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      console.log(err)
    } finally {
    }
  }

  useEffect(() => {
    getUsersList()
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div className={`card p-4 ${mode === 'dark' ? 'bg-light' : ''}`}>
        <div className='d-flex flex-md-row flex-column justify-content-between'>
          <div>
            <h1 className='font-size-16 fw-semibold'>
              {formatMessage({id: 'Usage Quota Tracking'})}
            </h1>
            <p className='font-size-12 text-muted'>
              {formatMessage({id: 'Summary of quota usage by your AI'})}
            </p>
          </div>
          {/* <div>
                        <button className='btn btn-primary w-100 mb-md-0 mb-4'
                            onClick={() => setIsModalActive(true)}>
                            {formatMessage({ id: 'Add More Quota' })}
                        </button>
                    </div> */}
        </div>
        <div className='d-flex flex-md-row flex-column justify-content-between align-items-center'>
          <div className='d-flex gap-4'>
            <div className='text-muted d-flex align-items-center gap-2'>
              <div
                style={{
                  width: '14px',
                  height: '14px',
                  borderRadius: '50%',
                  backgroundColor: '#4776E6',
                }}
              />
              <div className='d-flex align-items-center gap-2'>
                <div style={{fontWeight: 'bold'}} className='text-dark font-size-13'>
                  {`${Math.round(
                    (quotaOverviewData?.aiSearchAndRetrievals ?? []).reduce(
                      (acc, item) => acc + (item?.totalChats || 0),
                      0
                    )
                  )}`}
                </div>
                <span className='font-size-13'>{formatMessage({id: 'AI Search & Retrieval'})}</span>
              </div>
            </div>
            <div className='text-muted d-flex align-items-center gap-2'>
              <div
                style={{
                  width: '14px',
                  height: '14px',
                  borderRadius: '50%',
                  backgroundColor: '#0D216D',
                }}
              />
              <div className='d-flex align-items-center gap-2'>
                <div style={{fontWeight: 'bold'}} className='text-dark font-size-13'>
                  {`${Math.round(
                    (quotaOverviewData?.fileProcessing ?? []).reduce(
                      (acc, item) => acc + (item?.totalFiles || 0),
                      0
                    )
                  )}`}
                </div>
                <span className='font-size-13'>{formatMessage({id: 'File Processing'})}</span>
              </div>
            </div>
          </div>
          <div className='d-flex flex-md-row flex-column gap-md-4 gap-0 align-items-center w-md-50 w-100'>
            <div className='d-flex align-items-center w-100 justify-content-end'>
              <form className='form-check form-check-custom form-check-solid form-check-primary form-switch pb-3 pt-3'>
                <label className='togglebtn'>
                  <input
                    className='togglebtn__input'
                    name='model.app.sidebar.default.minimize.desktop.hoverable'
                    defaultChecked={isCumulative}
                    type='checkbox'
                    id='checkbox-id'
                    onChange={() => setIsCumulative(!isCumulative)}
                  />
                  <div className='togglebtn__fill'></div>
                </label>
                {formatMessage({id: 'Cumulative'})}
              </form>
            </div>
            <div className='d-flex gap-4 w-100'>
              <div className='d-flex align-items-center w-100 gap-md-4 gap-2'>
                <div className='dropdown-center w-100'>
                  <button
                    className='form-select form-select-sm form-select-solid h-100 w-100 text-nowrap text-start'
                    // style={{ minWidth: '60px' }}
                    type='button'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                  >
                    {formatMessage({id: 'All Members'})}
                  </button>
                  <ul className='dropdown-menu bg-white p-0'>
                    {userList &&
                      userList.map((user) => (
                        <li className='cursor-pointer dropdown-item' key={user.userId}>
                          <div
                            className='d-flex align-items-center gap-3 p-2'
                            style={{borderBottom: '1px solid #DBDFE9'}}
                          >
                            <input
                              type='checkbox'
                              className='form-check-input h-20px w-20px'
                              checked={isChecked(user.userId)}
                              onChange={() => handleCheckboxChange(user.userId)}
                            />
                            <div>
                              <h1 className='font-size-14 mb-1'>
                                {user.firstName} {user.lastName}
                              </h1>
                              <p className='font-size-12 m-0 text-muted'>{user.email}</p>
                            </div>
                          </div>
                        </li>
                      ))}
                  </ul>
                </div>
                {/* <div className='dropdown-center w-100'>
                  <select
                    className='form-select form-select-sm form-select-solid h-100 w-100 text-center'
                    // style={{ minWidth: '60px' }}
                    data-control='select2'
                    data-placeholder='Latest'
                    data-hide-search='true'
                    value={selectedDataActivity}
                    onChange={(e) => setSelectedDataActivity(e.target.value)}
                  >
                    <option className='bg-light' value='thisWeek'>{formatMessage({ id: 'This Week' })}</option>
                    <option className='bg-light' value='thisMonth'>{formatMessage({ id: 'This Month' })}</option>
                    <option className='bg-light' value='last6Months'>{formatMessage({ id: 'Last 6 Months' })}</option>
                    <option className='bg-light' value='thisYear'>{formatMessage({ id: 'This Year' })}</option>
                  </select>
                </div> */}
                <div className='dropdown-center w-100'>
                  <select
                    className='form-select form-select-sm form-select-solid'
                    data-control='select2'
                    data-placeholder='Latest'
                    data-hide-search='true'
                    value={selectedDataActivity}
                    onChange={(e) => setSelectedDataActivity(e.target.value)}
                  >
                    <option className='bg-light' value='thisWeek'>
                      {formatMessage({id: 'This Week'})}
                    </option>
                    <option className='bg-light' value='thisMonth'>
                      {formatMessage({id: 'This Month'})}
                    </option>
                    <option className='bg-light' value='last6Months'>
                      {formatMessage({id: 'Last 6 Months'})}
                    </option>
                    <option className='bg-light' value='thisYear'>
                      {formatMessage({id: 'This Year'})}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Card className={`w-100 mb-4 mb-md-auto ${mode === 'dark' ? 'bg-light' : ''}`}>
          {!isCumulative ? (
            !quotaOverviewData ? (
              <NoDataPage />
            ) :  isProcessing || isQuotaLoading ? (
              <Skeleton
                width={'100%'}
                height={'300px'}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                className='mt-4'
              />
            ) : (
              <QuotaBarColumnChart dataActivity={quotaOverviewData} />
            )
          ) : !graphData.series && !graphData.categories ? (
            <NoDataPage />
          ) :  isProcessing || isQuotaLoading ? (
            <Skeleton
              width={'100%'}
              height={'300px'}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
              className='mt-4'
            />
          ) : (
            <QuotaOverviewGraph series={graphData.series} categories={graphData.categories} />
          )}
        </Card>
      </div>
      <div className='my-4'>
        <div
          className='p-2 rounded d-flex align-items-center gap-2'
          style={
            mode === 'dark'
              ? {background: '#6C4F2C', border: '2px dashed #FFC700'}
              : {background: '#FFF8DD', border: '2px dashed #FFC700'}
          }
        >
          <img src={Info} alt='Info' />
          <p className='m-0 text-dark font-size-14'>
            <span className='fw-bold'>{formatMessage({id: 'Important: '})}</span>
            {formatMessage({
              id: 'Additional purchased quota will be used only after the monthly subscription quota is depleted. The subscription quota resets monthly on the start date of your subscription.',
            })}
          </p>
        </div>
      </div>
      <div
        className={`card ${
          mode === 'dark' ? 'bg-light' : ''
        } d-flex flex-md-row flex-column justify-content-between align-items-center my-4 rounded p-4`}
      >
        <div className='d-flex'>
          <p className='mb-0'>
            <img src={Calendar} alt='Calendar' className='me-2' />
            <span className='text-muted'>{formatMessage({id: 'Quota Usage Period: '})}</span>
            { isProcessing || isQuotaLoading ? (
              <Skeleton
                width={100}
                height={15}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                className=''
              />
            ) : (
              planDates?.quotaUsagePeriodFrom && planDates?.quotaUsagePeriodTo
              ? `${planDates.quotaUsagePeriodFrom} - ${planDates.quotaUsagePeriodTo}`
              : '-'
            )}
          </p>
          <ToolTipUI
            tooltipText={formatMessage({
              id: 'This period determines the quota limit shown below. Your quota resets at the start of each month based on your billing start date. Even for yearly subscriptions, the quota resets every month on the same date as your billing start date.',
            })}
          />
        </div>
        <div className='d-flex'>
          <p className='mb-0'>
            <img src={Watch} alt='Watch' className='me-2' />
            <span className='text-muted'>
              {formatMessage({id: 'Estimated Limit Reset Date: '})}
            </span>
            { isProcessing || isQuotaLoading ? (
              <Skeleton
                width={100}
                height={15}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                className=''
              />
            ) : (
              planDates?.quotaUsagePeriodResetdate || '-'
            )}
          </p>
          <ToolTipUI
            tooltipText={formatMessage({
              id: 'This date is when your accounts quota limit gets reset.',
            })}
          />
        </div>
      </div>
      <div className='row'>
        {isProcessing || isQuotaLoading ? (
          <div className='d-flex flex-column gap-4'>
            <StorageCardSkeleton />
            <StorageCardSkeleton />
            <StorageCardSkeleton />
            <StorageCardSkeleton />
          </div>
        ) : (
          initialItems &&
          initialItems.length > 0 &&
          initialItems.map((data: any, index: number) => (
            <div className='col-12 mb-6' key={index}>
              <StorageCard details={data} />
            </div>
          ))
        )}
      </div>
    </div>
  )
}

export default StorageAndAIUse
